<div class="card meetings">
  <div class="card-body mt-4">
    <div class="card-text">
      <lib-filter-list [configService]="listConfigService"></lib-filter-list>
    </div>
  </div>
</div>
